import styled from '@emotion/styled';
import { theme } from 'style';

export const StyledDiv = styled.div({
  color: theme.colors.secondary,
  fontWeight: 600,
  padding: '24px 0px 12px 0px',
});